import { render, staticRenderFns } from "./NewFileRequestDialogIntro.vue?vue&type=template&id=0778d7a9&scoped=true"
import script from "./NewFileRequestDialogIntro.vue?vue&type=script&lang=ts"
export * from "./NewFileRequestDialogIntro.vue?vue&type=script&lang=ts"
import style0 from "./NewFileRequestDialogIntro.vue?vue&type=style&index=0&id=0778d7a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0778d7a9",
  null
  
)

export default component.exports